export default "// Type your solution below\ntype ship_code = string\nlet my_ship : ship_code = \"020433\"\nlet my_ship = \"222031\"\n";